<template>
  <div class="message-block">
    <div class="title">
      選擇或寫下祝福<span>限30字</span>
      <span class="count">剩餘30字</span>
    </div>

    <div class="select" :class="{ focused }" @click="selected">
      <div :class="{ init: selectedIndex !== -1 }">
        <template v-if="message">
          {{ message }}
        </template>
        <template v-else>請選句好咖祝福</template>
      </div>
      <img class="image" :src="iconArrowDown" />
    </div>
    <div v-if="focused" class="select-dropdown">
      <div
        v-for="(msg, idx) in messageList"
        v-show="msg"
        :key="idx"
        class="item"
        :class="{ active: idx === selectedIndex }"
        @click="selectMessage(idx)"
      >
        <div>{{ msg }}</div>
      </div>
    </div>

    <div
      class="picture-block"
      :class="[
        { 'animate-crash': animateCrash },
        { 'animate-scale': animateScale },
      ]"
    >
      <textarea
        v-if="!animateCrash && !animateScale"
        id="t1"
        class="message"
        rows="5"
        cols="33"
        placeholder="點選此處寫下祝福"
        maxlength="30"
        :value="selectedIndex !== -1 ? message : ''"
        @input="limitText"
      ></textarea>

      <div>
        <img v-show="picture" :src="picture" @click="handleEgg" />
      </div>
    </div>
    <div class="notice">
      <div>
        <img :src="iconAlert" />
      </div>
      <div>提醒：</div>
      <div>
        小卡僅供個人通知用途,傳送前請確認與商品轉贈對象相同,以免造成接收者混淆
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import iconAlert from '../assets/icon/i-alert.svg';
import iconArrowDown from '../assets/icon/i-arrow-down.svg';

export default {
  name: 'MessageBlock',
  props: {
    picture: {
      type: String,
      default: '',
    },
    messageList: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const store = useStore();

    const focused = ref(false);
    let count = 0;
    let eggOn = false;
    const selected = () => {
      focused.value = !focused.value;
      count++;

      if (count > 30 && !eggOn) {
        eggOn = true;
        count = 0;

        setTimeout(() => {
          eggOn = false;
        }, 5000);
      }
    };

    const selectedIndex = ref(-1);
    const message = ref('請選句好咖祝福');
    const selectMessage = (index) => {
      selectedIndex.value = index;
      message.value = props.messageList[index];
      focused.value = !focused.value;
      setTimeout(() => {
        limitText();
      }, 50);
    };

    const resetMessage = () => {
      message.value = '';
      selectedIndex.value = -1;
      store.commit('setMessage', '');
      store.commit('setButtonStatus', true);
    };

    const limitText = () => {
      const textareaMessage = document.querySelector('.message');
      const count = document.querySelector('.count');
      count.innerHTML = `剩餘${30 - textareaMessage.value.length}字`;
      const disable = textareaMessage.value.length === 0 ? true : false;

      store.commit('setButtonStatus', disable);
      store.commit('setMessage', textareaMessage.value);

      if (textareaMessage.value.length === 0) {
        selectedIndex.value = -1;
        message.value = '';
        return;
      }
    };

    // egg
    let eggCount = 0;
    const animateCrash = ref(false);
    const animateScale = ref(false);
    const handleEgg = () => {
      eggCount++;

      if (eggCount > 5 && eggOn) {
        eggOn = false;
        eggCount = 0;

        setTimeout(() => {
          animateCrash.value = true;
        }, 500);

        setTimeout(() => {
          animateCrash.value = false;
          animateScale.value = true;
        }, 1500);

        setTimeout(() => {
          animateCrash.value = false;
          animateScale.value = false;
        }, 2500);

        setTimeout(() => {
          animateCrash.value = true;
          animateScale.value = true;
        }, 3000);

        setTimeout(() => {
          animateCrash.value = false;
          animateScale.value = false;
        }, 5000);
      }
    };

    return {
      focused,
      selected,
      message,
      selectedIndex,
      selectMessage,
      resetMessage,
      limitText,
      iconAlert,
      iconArrowDown,
      handleEgg,
      animateCrash,
      animateScale,
    };
  },
};
</script>

<style lang="scss" scoped>
.message-block {
  position: relative;

  .title {
    text-align: left;
    font-size: 16px;
    line-height: 20px;
    color: #333333;
    margin-bottom: 16px;

    span {
      font-size: 12px;
      line-height: 20px;
      text-align: center;
      color: #3bc3af;
      margin-left: 16px;
    }
  }

  .select {
    width: 100%;
    height: 48px;
    background: #fcfcfc;
    border: 1px solid #c2c2c2;
    box-sizing: border-box;
    border-radius: 8px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 16px;
    position: relative;
    margin-bottom: 16px;
    font-size: 14px;
    line-height: 20px;

    div {
      width: 90%;
      word-break: nowrap;
      white-space: nowrap;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-align: left;
      color: #c2c2c2;

      &.init {
        color: #333333;
      }
    }

    .image {
      position: absolute;
      top: calc(50% - 10px);
      right: 12px;
    }

    &.focused {
      box-shadow: 0px 0px 0px 3px rgba(0, 140, 214, 0.2);
    }
  }

  .select-dropdown {
    width: 100%;
    padding: 20px 8px;
    background: #fcfcfc;
    border: 1px solid #c2c2c2;
    box-sizing: border-box;
    border-radius: 8px;
    position: absolute;
    z-index: 5;
    padding: 8px 8px;
    top: 92px;

    .item {
      width: 100%;
      height: 40px;
      padding: 10px 12px;
      font-size: 14px;
      line-height: 20px;
      text-align: left;
      color: #828282;

      div {
        width: 100%;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      &.active {
        background: #e7f5fd;
        border-radius: 4px;
        color: #4f4f4f;
      }
    }
  }

  .picture-block {
    width: 100%;
    position: relative;
    .message {
      width: 80%;
      height: 96px;
      padding: 10px;
      line-height: 1.5;
      border-radius: 5px;
      border: 1px solid rgba(255, 255, 255, 0);
      z-index: 3;
      background-color: #ffffff55;
      position: absolute;
      left: 10%;
      top: calc(50% - 24px);
      outline: none;
      font-size: 16px;
      color: #000000;
    }

    div {
      border-radius: 8px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 100%;
        height: 100%;
        transition: all 3s;
      }
    }

    &.animate-crash {
      animation: crash 0.01s infinite;
    }

    &.animate-scale {
      img {
        animation: scale 0.05s infinite;
      }
    }
  }

  @keyframes crash {
    0% {
      transform: rotate(-5deg);
    }
    100% {
      transform: rotate(5deg);
    }
  }

  @keyframes scale {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0.9);
    }
  }

  .notice {
    display: flex;
    justify-content: flex-start;
    margin: 16px 0;

    & div {
      font-size: 12px;
      line-height: 18px;
    }

    div:nth-child(1) {
    }
    div:nth-child(2) {
      color: #3bc3af;
      margin-left: 5px;
      min-width: 36px;
    }
    div:nth-child(3) {
      text-align: left;
      color: #c2c2c2;
    }
  }
}
</style>
